<template>
  <v-list-item v-bind="{ ...$attrs, ...$props }" v-on="$listeners">
    <slot />
  </v-list-item>
</template>

<script>
import { VListItem } from 'vuetify/lib';

export default {
  name: 'core-list-item',
  isCustomElement: false,
  components: {
    VListItem,
  },
};
</script>
